var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('div',{staticClass:"titbox"},[_c('p',{staticClass:"commp3 sub_title fwb"},[_vm._v("다운로드")])]),_c('div',{staticClass:"sub__content form__ver_1 bg_white mt30"},[_c('div',[_vm._v("다운로드 내용")])])])}
var staticRenderFns = []

export { render, staticRenderFns }